import { observer } from 'mobx-react-lite';
import { DATA } from '../../game/data';
import { Popup } from './Reusable/Popup';
import { ProgressBar } from './Reusable/ProgressBar';
import { GreenButton } from './Reusable/GreenButton';
import { IMAGES } from '../../game/data/images';
import { COLORS } from '../../game/data/colors';
import { formatNumber } from '../../game/helpers';
import { MAX_OFFLINE_HOURS, OFFLINE_INCOME } from '../../game/offlineIncome';
import { TextButton } from './Reusable/TextButton';
import { POPUP } from '../../game/popupManager';
import { CrazySDK } from '../../crazySDK';
import { tryStartAudio } from '../../game/audio';

export const OfflineIncomePopup: React.FC = observer(() => {
  if (OFFLINE_INCOME.data === null) {
    return null;
  }

  const collectIncome = (isX2: boolean) => {
    tryStartAudio();

    if (!isX2) {
      OFFLINE_INCOME.collect(false);
    } else {
      DATA.setIsVideoPlaying(true);
      const callbacks = {
        adFinished: () => {
          DATA.setIsVideoPlaying(false);
          OFFLINE_INCOME.collect(true);
        },
        adError: (error: any) => {
          DATA.setIsVideoPlaying(false);
          OFFLINE_INCOME.collect(false);
          POPUP.showRewardedVideoErrorPopup();
          console.log('Error midgame ad', error);
        },
        adStarted: () => {},
      };
      CrazySDK.ad.requestAd('rewarded', callbacks);
    }
  };

  const noIncomeContinueClick = () => {
    tryStartAudio();
    OFFLINE_INCOME.clear();
  };

  return (
    <Popup
      width={400}
      onClose={() => {
        DATA.setOpenPopup(null);
      }}
    >
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h1>Offline income</h1>
        <h2>
          <span style={{ color: COLORS.green_500 }}>$</span>
          {formatNumber(OFFLINE_INCOME.data.money)}
        </h2>
        {OFFLINE_INCOME.data.errorCode === 'no-managers' && (
          <div style={{ color: COLORS.yellow_500, fontSize: '0.8rem' }}>At least one manager is required to earn offline income</div>
        )}
        {OFFLINE_INCOME.data.errorCode === 'not-enough-time' && (
          <div style={{ color: COLORS.yellow_500, fontSize: '0.8rem' }}>You need to be at least 1 minute offline to earn income</div>
        )}
        {OFFLINE_INCOME.data.errorCode === 'too-much-time-offline' && (
          <div style={{ color: COLORS.yellow_500, fontSize: '0.8rem' }}>Maximum offline time is {MAX_OFFLINE_HOURS} hours</div>
        )}
        <div style={{ textAlign: 'center' }}>
          {OFFLINE_INCOME.data.money === 0 && <GreenButton onClick={noIncomeContinueClick}>Continue</GreenButton>}
          {OFFLINE_INCOME.data.money > 0 && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 16 }}>
              <GreenButton style={{ display: 'inline-flex', alignItems: 'center', fontSize: '1rem' }} onClick={() => collectIncome(true)}>
                <img src={IMAGES.ICONS.video} style={{ height: '1.2rem', marginRight: 4 }} />
                COLLECT X2
              </GreenButton>
              <TextButton onClick={() => collectIncome(false)}>COLLECT</TextButton>
            </div>
          )}
        </div>
        <div className="tooltip-text">Buy and upgrade airplanes, managers and lounges to increase your offline income.</div>
      </div>
    </Popup>
  );
});
